import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { t } from "i18next";
import api from "../../../helpers/api/Api";
import ApiUrls from "../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../helpers/api/errors/ShowStatus";
import { getGraphTitle } from "../../../components/GraphCard/functions/getGraphTitle";
import Statistic from "./Statistic";
import GraphCard from "../../../components/GraphCard/graphCard";
import "./Statistic/components/dashboard-st-table.css";

function StatisticTable({ graphData, index, handleGraphChange }) {
  const [data, setData] = useState();

  useEffect(() => {
    if (graphData.ip) {
      getTable();
    }
  }, [graphData]);

  const getTable = () => {
    const formData = new FormData();
    formData.append("ip", graphData.ip);

    const snackArgs = {
      item: `${t("site.site")} ${graphData?.site?.name}`,
      op: t("report.get_data")
    };

    api.post(ApiUrls.reports.stats, formData)
       .then((response) => {
         if (response.data.status === "success") {
           let resData = response.data.content;
           setData(resData);
         } else {
           showStatus("error", snackArgs);
         }
       })
       .catch((error) => {
       });
  }

  return (
     <Grid item md={12} xs={12}>
       <GraphCard
          graphData={graphData}
          title={getGraphTitle(graphData, "dashboard-statistic")}
          getChart={getTable}
          handleGraphClear={() => handleGraphChange("remove", index)}
          clearable
       >
         <Statistic data={data} />
       </GraphCard>
     </Grid>
  );
}

export default StatisticTable;
